import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import PopupWrapper from "../../Common/PopupWrapper";
import {renderHTML} from "@mnjsplatform/data/lib/utils/htmlUtils";
import GridView from "@mnjsplatform/components/lib/common/GridView/GridView";
import i18next from "i18next";

class BenefitForm extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            isDataReady: false
        }
    }

    componentDidMount() {
        this.initialize();
    }

    initialize = async () => {
        await this.props.dispatch(this.props.dataItem.execute(this.props.rowKey));
        this.setState({isDataReady: true});
    }

    renderParams = (h) => {
        return (<div className="row">
            <div className="col-md-12">
                {h.fs.map((fi) => {
                    const fn = fi.Name;
                    return (<React.Fragment key={fn}>
                        <div className="row">
                            <div className="col-md-3 field-title">
                                {h.lbl(fn)}
                            </div>
                            <div className="col-md-9">
                                {h.ed(fn)}
                            </div>
                        </div>
                        <hr/>
                    </React.Fragment>)
                })}
            </div>
        </div>)
    }

    renderCellEx = (cellParams) => {
        if (cellParams.fieldInfo.Name === 'ResText') {
            return renderHTML(cellParams.row[cellParams.fieldInfo.Name]);
        }
        return cellParams.renderCellDefault(cellParams.row, cellParams.fieldInfo, cellParams.fieldIndex);
    }

    render() {
        if (!this.state.isDataReady) return null;
        return (<PopupWrapper popupVisible={true} title={this.props.title} onClose={this.props.onClose}
                              instructionId="BenefitForm"
                              staticTitle={i18next.t("Benefits_Explanation")}
                              maxWidthBody="600px">
            <GridView dataItem={this.props.dataItem} showHeader={false}
                      overrideVisibility={{"ResText": true}}
                      renderCellEx={this.renderCellEx}
            />
        </PopupWrapper>)
    }
}

BenefitForm.propTypes = {
    dispatch: PropTypes.func.isRequired,
    dataItem: PropTypes.object,
    onClose: PropTypes.func,
    title: PropTypes.string,
    rowKey: PropTypes.object
}

BenefitForm.defaultProps = {}

function mapStateToProps(state, ownProps) {
    return {
        dataItem: state.subBenefitsState.CalcKernelRep_DisplayUserBenefits
    }
}

export default connect(mapStateToProps)(BenefitForm)